<template>
    <b-overlay :show="loading" rounded="sm" >
        <b-modal
        size="lg"
        v-model="itemVisible"
        @ok="handleOk"
        class="pt-8"
        body-class="p-2"
        centered
        header-class="p-0"
        footer-class="d-flex justify-content-center border-0"
        content-class="custom-model-wrap"
      >
        <template #modal-title>
          <div class="title-block text-center p-2">{{ $translate('assets') }}</div>
        </template>
      
        <template #default>
          <div class="create-item-popup">
            <b-form ref="form" @submit.stop.prevent="handleSubmit">
              <b-row>
                <b-col cols="12" class="mt-3">
                  <label class="mb-3"><strong>{{ $translate('asset') }}</strong></label>
                  <b-form-input
                  id="input-asset-name"
                  name="input-asset-name"
                  :placeholder="$translate('name')"
                  type="text"
                  v-model="itemModel.asset_name"
                 disabled
                />
                </b-col>
      
                <b-col cols="6" class="mt-3">
                  <label class="mb-3"><strong>{{ $translate('asset_description') }}</strong></label>
                  <b-form-textarea
                    id="input-asset_description"
                    v-model="itemModel.asset_description"
                    disabled
                  ></b-form-textarea>
                </b-col>
      
                <b-col cols="6" class="mt-3">
                  <label class="mb-3"><strong>{{ $translate('estimated_rental_days') }}</strong></label>
                  <b-form-input
                    id="input-estimated_rental_days"
                    name="input-estimated_rental_days"
                    :placeholder="$translate('estimated_rental_days')"
                    type="number"
                    v-model="itemModel.estimated_rental_days"
                 
                  />
                </b-col>
              </b-row>
            </b-form>
          </div>
        </template>
      
        <template #modal-footer="{ ok }">
          <div class="mt-3 d-flex">
            <b-button id="cancel-label-asset-item-btn" :disabled="submitting" variant="info" @click="itemVisible = false" class="m-1">
              {{ $cancelLabel() }}
            </b-button>
            <b-button id="submit-asset-item-btn" :disabled="submitting" variant="info" class="m-1" @click="ok">
             submit
            </b-button>
          </div>
        </template>
      </b-modal>
        <b-card :class="isCrm">
            <!-- Details Dialog -->
            <ReportsDialog ref="reportsDialog" :report-list="reportList" :query="reportQuery" title="Asset Reports" />
            <b-card-header class="assets-filter">
                <b-row class="mt-2">
                    <b-col cols="12" class="search-field">
                        <div class="input-group">
                            <b-form-input type="text" id="search-task-or-asset" :placeholder="crm ? $translate('search_tasks') : $translate('search_assets')
                                " v-model="query"></b-form-input>
                            <div class="input-group-prepend bg-transparent"><i class="mdi mdi-magnify"></i></div>
                        </div>
                    </b-col>
                </b-row>
               
                <b-row class="mt-3">
                    <b-col cols="6">
                        <div class="d-flex">
                            <b-button  id="list-filter-btn" variant="blue-button" v-if="hasPermissionView" class="me-2 d-flex"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate("filters") }}
                                <b-icon class="mt-1 ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button  id="list-filter-reset-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                            &nbsp;&nbsp;
                            <b-button v-if="show_rental"   :disabled="!anyItemChecked" variant="blue-button"  @click="createRental">Create Rental</b-button>
                        </div>
                    </b-col>
                    <b-col cols="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col>
                </b-row>

                <asset-query-builder v-show="toggle_filters" v-model="filters" :types="types" :crm="crm" :officers="officers" :asset-frequencies="frequencies"
                    :roles="roles" :crm-setting-value="crmSettingValue" />
            </b-card-header>
            
           
            
            <b-card-body class="pt-0">
                <b-col class="page-block"><strong>{{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{
                    pageCount }} {{ $translate('total') }}:
                        {{ pagination.total }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="assetFields" striped hover responsive :items="items">
                        <template #cell(check)="row" v-if="show_rental">
                            <input
                            :id="'select-order-check-box-' + row.item.id"
                              type="checkbox"
                              class="form-check-input"
                              v-model="row.item.checked"
                               @change="updateCheckedItems(row.item.id, row.item.checked)"
                            />
                          </template>
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-lsit-item-'+row.item.id" v-if="hasPermissionView" @click="viewAsset(row.item.id)" class="me-2"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                            <b-button
                            v-if="filters.available_for_rental == 'yes'"
                            :id="'view-order-rental-item-'+row.item.id"
                            class="me-1"
                            variant="pink-button"
                            @click="openItemModal(row.item)"
                            >
                            <i class="fa fa-handshake" style="color: #ffffff;"></i>
                            </b-button>

                        </template>

                        <template #cell(frequency)="{ value }">
                            <span>{{ getFrequencyType(value) }}</span>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="mt-4" v-model="pagination.page" :total-rows="pagination.total"
                            :per-page="pagination.pageSize" aria-controls="customerTable" :prev-text="$translate('previous')"
                            :next-text="$translate('next')" pills align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import assetMixins from '@/mixins/assetMixins'
import AssetQueryBuilder from './AssetQueryBuilder'
import ReportsDialog from '@/components/ReportsDialog'
import permissionsMixins from '@/mixins/permissionsMixins'
import { templates } from '@/exports/jsreport_templates'

export default {
    name: 'assets-itemList',
    components: { AssetQueryBuilder, ReportsDialog },
    props: [
        'type',
        'items',
        'title',
        'crm',
        'crmSettingValue',
        'officers',
        'roles',
        'types',
    ],
    mixins: [popupMixins, permissionsMixins, assetMixins],
    data() {
        return {
            query: '',
            toggle_filters: false,
            loading: false,
            filters: {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
                frequency: null,
                available_for_rental : null,
            },
            itemVisible: false,         
            selectedItemId: null,       
            itemModel: {                 
            asset_description: '',
            estimated_rental_days: null,
            asset_name: "",
            asset_id:null
            },
            rentalitemData: {},              
            rentalitems: [],                    
            submitting: false,           
            searchedAsset: null,
            checkedItems: [],         
        }
    },

    mounted() {
        
     this.$store.dispatch('assets/storeRentals', 
                null
                );
        if (this.$route.query.query) this.query = this.$route.query.query
        if(this.$store.state.assets.filters) {
            for(const key in this.$store.state.assets.filters){
                const value = this.$store.state.assets.filters[key];
               
                
            }
            if(this.$store.state.asset_rental.is_rental){
                console.log('this is calledddddddd',this.$store.state.asset_rental.is_rental)
                this.$set(this.filters, 'available_for_rental', 'yes')
                console.log('this is available_for_rental',this.filters.available_for_rental)
             }
        }
        this.doSearch()
    },
    computed: {
        isCrm() {
            return this.$route.name.slice(0, 3) == 'crm' ? 'crm-listing' : 'asset-listing'
        },
        reportList() {
            return [
                {
                    id: 'asset_details',
                    value: templates.RPT_SVR_AST_DET_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Service History',
                    label: this.$translate('asset_service_history'),
                },
                {
                    id: 'asset_header',
                    value: templates.RPT_SVR_AST_HED_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Summary Report',
                    label: this.$translate('asset_summary_report'),
                },
                {
                    id: 'asset_listing',
                    value: templates.RPT_SVR_ASSLISXLS_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Listing Report',
                    label: this.$translate('asset_listing_report'),
                },
                {
                    id: 'asset_service',
                    value: templates.RPT_SVR_ASSSERNEW_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Service Report New Version',
                    label: this.$translate('asset_service_report_new_version')
                },
                {
                    id: 'asset_service_pdf',
                    value: templates.RPT_SVR_ASSSERNEWPDF_TEMPLATE,
                    extension: 'pdf',
                    name: 'Asset Service Report PDF',
                    label: this.$translate('asset_service_report_pdf')
                },
                {
                    id: 'crm_report',
                    value: templates.RPT_SVR_CRM_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Activities',
                    label: this.$translate('asset_activities')

                },
            ]
        },
        reportQuery() {
            const { query } = this
            return { query, ...this.filters }
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            console.log('this.data', this.$store.state.assets.assets_pagination)
            return this.$store.state.assets.assets_pagination
        },
        user() {
            return this.$store.state.user
        },
        anyItemChecked() {
        return this.items.some(item => item.checked);
        },

        assetFields() {
            const { crm } = this
            const crmFields = [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                    stickyColumn: true,
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                    sortable: true
                },
                {
                    key: 'customer_id',
                    label: this.$translate('customer'),
                    formatter: (value, key, item) => item.customer.name,
                    sortable: true
                },
                // { key: 'model_no', label: this.$translate('model_no') },
                {
                    key: 'location_section_id',
                    label: this.$translate('location'),
                    formatter: (value, key, item) =>
                        (x => x.name + ', ' + x.location.address1)(
                            item.location_section
                        ),
                        sortable: true
                },
                {
                    key: 'frequency',
                    label: this.$translate('frequency'),
                    sortable: true
                },
                {
                    key: 'last_service_date',
                    label: crm ? this.$translate('last_visit') : this.$translate('last_service'),
                    sortable: true
                },
                {
                    key: 'next_service_date',
                    label: crm ? this.$translate('next_visit') : this.$translate('next_service'),
                    sortable: true
                },
                {
                    key: 'default_engineer',
                    label: this.$translate('agent'),
                    formatter: value =>
                        value ? value.first_name + ' ' + value.last_name : '',
                        sortable: true
                },
                // {
                //     key: 'default_engineer',
                //     label: this.$translate('agent'),
                //     formatter: value =>
                //         value ? value.first_name + ' ' + value.last_name : '',
                // },
               
            ]
            if (crm) return crmFields
            else
                return [
                    {
                        key: 'check',
                        label: '', // Set the label to an empty string to hide the heading
                    },
                    {
                        key: 'id',
                        label: this.$translate('actions'),
                        stickyColumn: true,
                    },
                    {
                        key: 'name',
                        label: this.$translate('name'),
                        sortable: true
                    },
                    {
                        key: 'customer_id',
                        label: this.$translate('customer'),
                        formatter: (value, key, item) => item.customer.name,
                        sortable: true
                    },
                    {
                    key:'master_item',
                    label: this.$translate('default_rental_rate'),
                    formatter: value =>
                    value ? value.default_rental_rate:'',
                    sortable: true

                    },
                    { key: 'model_no', label: this.$translate('model_no'),sortable: true },
                    { key: 'serial_no', label: this.$translate('serial_no'),sortable: true },
                    {
                        key: 'location_section_id',
                        label: this.$translate('location'),
                        formatter: (value, key, item) =>
                            (x => x.name + ', ' + x.location.address1)(
                                item.location_section
                            ),
                    },
                    // {
                    //     key: 'frequency',
                    //     label: this.$translate('frequency'),
                    // },
                    // {
                    //     key: 'last_service_date',
                    //     label: crm ? this.$translate('last_visit') : this.$translate('last_service'),
                    // },
                    // {
                    //     key: 'next_service_date',
                    //     label: crm ? this.$translate('next_visit') : this.$translate('next_service'),
                    // },
                    {
                        key: 'default_engineer',
                        label: this.$translate('agent'),
                        formatter: value =>
                            value ? value.first_name + ' ' + value.last_name : '',
                            sortable: true
                    },
              
                    {
                        key: 'type_id',
                        label: this.$translate('type'),
                        formatter: (value, key, item) => item.type.name,
                        sortable: true
                    },
                    { key: 'warranty_expiry_date', label: this.$translate('warranty') },
                    { key: 'contract_expiry_date', label: this.$translate('contract') },
                    
                ]
        },
        show_rental(){
            if(this.filters.available_for_rental){
                return true;
            }else{
                return false;
            }
        }
    },

    watch: {
        'crmSettingValue.type_id': function (type_id) {
            if (this.crm) this.$set(this.filters, 'type_id', type_id || null)
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function () {
              
                this.doSearch()
            },
            deep: true,
        },
        query: function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        },
    },
    created(){
        
    },
    methods: {
        getCrmQuery() {
            return this.reportQuery;
        },
        viewAsset(id) {
            const path = `${this.$route.path}/${id}`;
            console.log('path',path);
            this.$router.push({ path })
        },

        resetFilters() {
            this.filters = {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
                frequency: null,
            }
            this.doSearch()
        },
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch: _.debounce(async function () {
            await this.pureSearch()
        }, 500),
        async pureSearch(doReset) {
            console.log('pure_search is called');
            try {
                this.loading = true
                let {
                    query,
                    pagination: { page },
                    filters,
                    crm,
                    crmSettingValue: { type_id },
                } = this
               
                if(page == 0 || page == null){
                    page = 1;
                }
                if (crm) {
                    this.$set(filters, 'type_id', type_id || null)
                    this.$set(filters, 'warranty_from', null)
                    this.$set(filters, 'warranty_to', null)
                } else if (doReset) {
                    this.$set(filters, 'type_id', null)
                }

                this.$set(filters, 'crm_type_id', type_id || null)
                
                this.$router.push({
                    query: { page, query, ...this.filters, type_id },
                });

                await this.$store.dispatch('assets/fetch', {
                    query,
                    page,
                    filters,
                })
            } catch (err) {
                console.error('loading error', err)
            } finally {
                this.loading = false
            }
        },
        showDetailsDialog() {
            this.$refs.reportsDialog.show()
        },
        getFrequencyType(value) {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            const obj = (frequencies || []).find(x => x.value == value)
            return obj ? obj.name : value == '0' ? 'One Off' : ''
        },
        openItemModal(item) {
            // Set the selected item ID
            this.selectedItemId = item.id;
            
            // Check if the item already has stored data, otherwise set default values
            if (this.rentalitemData[item.id]) {
            this.itemModel = { ...this.rentalitemData[item.id] }; // Copy the existing data
            } else {

             
            this.itemModel = {
                asset_description: item.description,
                estimated_rental_days: null,
                asset_name :item.name,
                asset_id : item.id
            };
            }

            // Show the modal
            this.itemVisible = true;
        },
        
        // Handle modal submission
        handleOk() {
            this.submitting = true;
            
            // Save the data for the current item
            this.rentalitemData[this.selectedItemId] = { ...this.itemModel };
            
            // Hide the modal and reset the submitting state
            this.itemVisible = false;
            this.submitting = false;
        },
        updateCheckedItems(itemId, checked) {
        if (checked) {
       
        this.checkedItems.push(itemId);
        } else {
        
        this.checkedItems = this.checkedItems.filter(id => id !== itemId);
        }
    },
     async createRental() {
        
        const selectedRentalItems = Object.keys(this.rentalitemData)
        .filter(key => this.checkedItems.includes(parseInt(key)))  
        .map(key => this.rentalitemData[key]);  
        await this.$store.dispatch('assets/storeRentals', 
                selectedRentalItems
                );
       this.$store.commit("locations/SET_LOCATION", {});
       this.$router.push("/ams/activities/0");
        console.log('temp asset rentals-----',this.$store.state.assets.temp_asset_rental);
        if (selectedRentalItems.length === 0) {
        console.log('No items selected for rental.');
        return;
        }

    }
    },

    beforeDestroy() {
    this.$store.commit('asset_rental/SET_IS_RENTAL', false);
    }

}
</script>
<style></style>
